module.exports = __webpack_public_path__ + "img/Gabon.14362fbc.gif";